"use client";

import { c as _c } from "react/compiler-runtime";
import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
export interface RecaptchaCheckboxHandle {
  reset: () => void;
}
export interface RecaptchaCheckboxProps {
  onToken: (token: string | null) => void;
  theme?: "light" | "dark";
}
export const RecaptchaCheckbox = forwardRef<RecaptchaCheckboxHandle, RecaptchaCheckboxProps>(function RecaptchaCheckbox(t0, ref) {
  const $ = _c(13);
  const {
    onToken,
    theme: t1
  } = t0;
  const theme = t1 === undefined ? "light" : t1;
  const siteKey = process.env.NEXT_PUBLIC_RECAPTCHA_CHECKBOX_SITE_KEY;
  const widgetRef = useRef(null);
  const [loadFailed, setLoadFailed] = useState(false);
  let t2;
  if ($[0] !== onToken) {
    t2 = () => ({
      reset: () => {
        widgetRef.current?.reset();
        onToken(null);
      }
    });
    $[0] = onToken;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  useImperativeHandle(ref, t2);
  if (!siteKey) {
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="text-[0.8rem] text-[var(--color-danger)]">Security check is not configured. Please contact support.</div>;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    return t3;
  }
  if (loadFailed) {
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="text-[0.8rem] text-[var(--color-danger)]">Security check failed to load. Please refresh the page.</div>;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  let t3;
  let t4;
  let t5;
  if ($[4] !== onToken) {
    t3 = token => onToken(token);
    t4 = () => onToken(null);
    t5 = () => {
      setLoadFailed(true);
      onToken(null);
    };
    $[4] = onToken;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5 || $[11] !== theme) {
    t6 = <div className="flex justify-center"><ReCAPTCHA ref={widgetRef} sitekey={siteKey} theme={theme} onChange={t3} onExpired={t4} onErrored={t5} /></div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = theme;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
});